<div class="icon-switch-content" [ngClass]="{readonly, disabled, 'has-selection': isAnySelected()}">
    <div class="icons" *ngIf="hasIcons()">
        <twc-icon *ngFor="let option of switchOptions; let i = index" [ngClass]="{inactive: !isActive(i)}"
            (click)="selectOption(i)" [shape]="icons[i]" [size]="48"></twc-icon>
    </div>
    <twc-switch [disabled]="disabled || readonly" [selectedIndex]="defaultOptionIndex ?? NOT_SELECTED"
        (selectionChanged)="onChange($event)">
        <twc-switch-button *ngFor="let option of switchOptions; let i = index" [data]="i">
            <span>{{ option.label| translate }}</span></twc-switch-button>
    </twc-switch>
</div>